export function replaceAll(str) {
    const regex = /[^a-zA-Z0-9]/ig;
    const regex1 = /__|___/ig;
    const replacement = '_'
    const str1 = str.replaceAll(regex, replacement)
    const str2 = str1.replaceAll(regex1, replacement)
    return str2
}
